function eventKey(event) {
    return [
        event.event,
        event.cueId || '',
        event.markerId || '',
        event.layerId || '',
        event.pageIndex != null ? String(event.pageIndex) : ''
    ].join(':');
}

function entityKey(event) {
    if (event.cueId && event.event.startsWith('cue.')) {
        return `cue:${event.cueId}`;
    }
    if (event.markerId && event.event.startsWith('marker.')) {
        return `marker:${event.markerId}`;
    }
    if (event.layerId && event.event.startsWith('layer.')) {
        return `layer:${event.layerId}`;
    }
    return null;
}

export function coalesceStructureEvents(events, structureFullEvent) {
    if (events.some(e => e.event === structureFullEvent)) {
        return [{ event: structureFullEvent }];
    }
    const map = new Map();
    for (const event of events) {
        const key = entityKey(event) || eventKey(event);
        const hasPrevious = map.has(key);
        const previous = map.get(key);
        const isStaleUpdateAfterDelete =
            event.event.endsWith('.updated') &&
            ((previous && previous.event.endsWith('.deleted')) ||
                (hasPrevious && previous === null));

        if (previous && previous.event.endsWith('.created') && event.event.endsWith('.updated')) {
            map.set(key, { ...event, event: previous.event });
        } else if (previous && previous.event.endsWith('.created') && event.event.endsWith('.deleted')) {
            map.set(key, null);
        } else if (!isStaleUpdateAfterDelete) {
            map.set(key, event);
        }
    }
    return [...map.values()].filter(Boolean);
}

/**
 * Debounced batch queue. All callers that enqueue during a window share one flush;
 * every enqueue promise resolves when that flush completes (none are orphaned on reset).
 */
export function createDebouncedNotifyQueue({ debounceMs, onFlush }) {
    let timer = null;
    let flushChain = Promise.resolve();
    const pendingEvents = [];
    const pendingResolvers = [];

    function enqueue(event) {
        pendingEvents.push(event);
        if (timer) {
            clearTimeout(timer);
        }
        return new Promise((resolve) => {
            pendingResolvers.push(resolve);
            timer = setTimeout(() => {
                timer = null;
                const batch = coalesceStructureEvents(
                    pendingEvents.splice(0, pendingEvents.length),
                    onFlush.structureFullEvent
                );
                const resolvers = pendingResolvers.splice(0, pendingResolvers.length);
                flushChain = flushChain
                    .catch(() => {})
                    .then(() => onFlush.flush(batch));
                Promise.resolve(flushChain).finally(() => {
                    resolvers.forEach(r => r());
                });
            }, debounceMs);
        });
    }

    return { enqueue };
}


// WEBPACK FOOTER //
// ./src/lib/noteslist-notify-queue.js